import React from 'react'
import styled from 'styled-components'
import { MenuList } from '@material-ui/core'

interface IMenuPCPopupProps {
  visible: boolean
  closeExpanded: () => void
  children?: React.ReactNode
}

export const MenuPCPopup = (props: IMenuPCPopupProps) => {
  const { visible, children } = props

  return (
    <Wrapper visible={visible}>
      <MenuList>
        <MenuListWrapper>{children}</MenuListWrapper>
      </MenuList>
    </Wrapper>
  )
}

const Wrapper = styled.div<{ visible: boolean }>`
  z-index: 1001;
  position: absolute;
  top: calc(100% + 12px);
  left: 0;
  transition: all 0.2s ease-in-out;
  opacity: ${(props) => (props.visible ? 1 : 0)};
  transform: ${(props) => (props.visible ? 'translateY(0)' : 'translateY(-8px)')};
  pointer-events: ${(props) => (props.visible ? 'auto' : 'none')};
  transition: opacity 150ms ease, transform 150ms ease;
`

const MenuListWrapper = styled.div`
  border-radius: 8px;
  padding: 12px 0;
  box-shadow: 0px 4px 12px 2px #00000033;
  font-family: Roboto-Regular, Roboto;
  background-color: #fff;

  .MuiListItem-button {
    font-family: Roboto-Regular, Roboto;
    color: #757575;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 24px;

    &:hover {
      background-color: transparent !important;
    }
  }
`
